<template>
    <div v-show='!disabled && isPickDate' class='calendar-box'>
      <b-calendar ref='bootstrapCalendar' v-model='inputValue' :date-disabled-fn='dateDisabled'
                  :date-info-fn='dateClass'
                  @context='changeDate' @input='inputChange(inputValue)' @selected='selectDate'></b-calendar>
    </div>
</template>

<script>
import { Utils } from '@/assets/js/utils';
import moment from 'moment';
import api from '../assets/js/api';

export default {
  name: 'ScheduleCalendar',
  props: {
    selectData: Array,
    date: String,
    startDate: String,
    endDate: String,
    id: String,
    centerId: String,
    centerLessonScheduleId: String,
    isPickDate: Boolean,
    ticketType: String,
    lessonTime: Number,
    startTime: String,
    endTime: String,
    reservedScheduleList: Array,
    selectedScheduleList: Array,
    selectedScheduleValueList: Array,
    selectFormRoom: Array,
    selectedRoom: Object,
    selectedTicketValueList: Array,
    staffNameList: Array,
    staffValueList: Array,
    staffId: {
      type: [Number, String],
      default: '',
    },
    showDateFormat: {
      default: 'YYYY-MM-DD',
      type: String,
    },
    showDateLocale: {
      default: 'ko',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    disabledBeforeToday: {
      default: false,
      type: Boolean,
    },
    disabledBeforeDate: {
      default: '',
      type: String,
    },
    disabledAfterDate: {
      default: '',
      type: String,
    },
    disabledDateList: {
      default() {
        return [];
      },
      type: Array,
    },
  },
  computed: {
    cId() {
      const {getters} = this.$store;
      return getters['auth/cId'];
    },
  },
  watch: {
    date(newVal) {
      this.inputValue = newVal;
    },
    startDate(newVal) {
      this.inputValue = newVal;
      // this.showValue = newVal;
    },
    endDate(newVal) {
      this.inputValue = newVal;
      // this.showValue = newVal;
    },
    staffId() {
      this.changeStaffId();// 재조회를 위한 함수 호출
    },
  },
  data() {
    return {
      inputValue: this.date,
      today: moment().format('YYYY-MM-DD'),
      showValue: '',
      holidays: [],
      lessonDate: {},
      value: '',
      context: null,
    };
  },
  mounted() {
    if (this.startDate) {
      this.inputValue = this.startDate;
    }
    if (this.endDate) {
      this.inputValue = this.endDate;
    }
    if (this.date) {
      this.showValue = this.date;
      this.date = this.date;
    }
  },
  created() {

  },
  methods: {
    setCalendarSelectedDate(selectedDate) {
      this.$refs.bootstrapCalendar.selectedYMD = selectedDate;
      this.$refs.bootstrapCalendar.activeYMD = selectedDate;
    },
    inputChange(date) {
      this.$emit('update', date);
      this.$emit('change', date, this.id);

      if (date !== '') {
        this.showValue = moment(date).locale(this.showDateLocale).format(this.showDateFormat);
      } else {
        this.showValue = '';
      }
    },
    outsideClick() {
      this.isPickDate = false;
    },
    resetDate() {
      this.inputDate = '';
    },
    dateDisabled(ymd, date) {
      // console.log('dateDisabled: ', ymd, date);
      if (this.disabledBeforeToday && moment(ymd).isBefore(this.today)) {
        return true;
      }

      if (this.disabledBeforeDate !== '' && moment(ymd).isBefore(this.disabledBeforeDate)) {
        return true;
      }

      if (this.disabledAfterDate !== '' && moment(ymd).isAfter(this.disabledAfterDate)) {
        return true;
      }

      if (this.disabledDateList && this.disabledDateList.length > 0) {
        for (const disabledDate of this.disabledDateList) {
          const {startDate, endDate} = disabledDate;
          if (!moment(ymd).isAfter(endDate) && !moment(ymd).isBefore(startDate)) {
            return true;
          }
        }
      }

      // 강사 및 함께 등록할 회원 필수 선택
      if( !this.staffId || (this.ticketType === 'D' && this.selectedTicketValueList.length < 1 ) ) {
        return true;
      }

      return false;
    },
    initShowValue() {
      this.shwoValue = '';
    },
    dateClass(ymd) {
      // console.log('dateClass: ', ymd);
      // 휴일 표시
      for (const d of this.holidays) {
        if (ymd === d) {
          return 'holiday-round';
        }
      }
      // 이미 등록된 예약 표시
      // console.log('lessonDate: ', this.lessonDate);
      if(this.staffId) {
        for (const lesson in this.lessonDate) {
          if (ymd === lesson) {
            for (const l of this.lessonDate[lesson]) {
              if( moment(this.startTime,'HH:mm').isSameOrAfter(moment(l.cls_less_start_tm.substr(0,5),'HH:mm'))
                && moment(this.startTime,'HH:mm').isBefore(moment(l.cls_less_end_tm.substr(0,5),'HH:mm'))
              ) {
                return 'reserved-round';
              }
            }
          }
        }
      }
      // 선택한 예약 표시
      for (const schedule of this.selectedScheduleValueList) {
        if(ymd === schedule.lessonDate) {
          return 'selected-round';
        }
      }
      return false;
    },
    // 이전 달, 다음 달로 넘길 때, 이벤트 함수..
    changeDate(context) {
      // console.log('context: ', context);
      this.context = context;
      // 선택된 달의 휴일을 구하기 위한 api파라메터 작성
      const ym = `${context.activeDate.getFullYear()}-${(context.activeDate.getMonth() + 1).toString().padStart(2, '0')}`;
      // 공통 컴포넌트이기 때문에 부모 컴포넌트에서 id를 주지 않을 경우.. 에러방지..

      // 휴일 구하기 함수..
      this.getMonthHolidays(this.cId, ym);

      // 이미 등록된 일정 달력 표시
      this.changeStaffId();
    },
    async selectDate(ymd, date) {
      /*
      console.log('selectDate ymd: ', ymd);
      console.log('selectDate date: ', date);
      console.log('lessonDate: ', this.lessonDate);
      console.log('this.selectFormRoom: ', this.selectFormRoom);
      console.log('selectedRoom : ', this.selectedRoom);
      */
      const roomName = (!this.selectedRoom || !this.selectedRoom.centerRoomId) ? '' : `/ ${this.selectFormRoom[0].room[this.selectedRoom.centerRoomId].name}`;
      const staffIndex = this.staffValueList.findIndex(staff => staff == this.staffId);
      const staffName = this.staffNameList[staffIndex];

      // 이미 등록된 일정 초기화
      let reserved = false;
      this.reservedScheduleList.length = 0;
      outer : for (const lesson in this.lessonDate) {
        if (ymd === lesson) {
          inner : for (const l of this.lessonDate[lesson]) {
            // console.log('l : ', l);
            const lessonStartTime = l.cls_less_start_tm.substr(0,5);
            const lessonEndTime = l.cls_less_end_tm.substr(0,5);
            const lessonStaffName = l.cls_less_staff_nm;
            const lessonTypeName = this.convertTicketTypeFormat(l.cls_less_type_cd);
            // 이미 등록된 일정 조회
            if( moment(this.startTime,'HH:mm').isSameOrAfter(moment(lessonStartTime,'HH:mm'))
              && moment(this.startTime,'HH:mm').isBefore(moment(lessonEndTime,'HH:mm'))
            ) {
              this.reservedScheduleList.push(`${ymd}(${l.cls_day_of_week}) ${lessonStartTime} ~ ${lessonEndTime} ${lessonTypeName}`);
              reserved = true;
              break outer;
              /*
              if( this.startTime === lessonStartTime) {
              this.reservedScheduleList.push(`${ymd}(${l.cls_day_of_week}) ${lessonStartTime} ~ ${lessonEndTime} ${lessonStaffName} 강사`);
              reserved = true;
              break outer;
            }
              */
            }
          }
        }
      }

      // 선택한 일정 추가
      if ( !reserved ) {
        // console.log('selectedTicketValueList: ', this.selectedTicketValueList);
        const currentDate = moment(ymd,'YYYY-MM-DD');

        // 이미 선택된 일정이면 선택 취소
        let isAlreadySelected = false;
        for(let i = 0; i < this.selectedScheduleValueList.length; i++) {
          if(this.selectedScheduleValueList[i].lessonDate === ymd)  {
            this.selectedScheduleList.splice(i, 1);
            this.selectedScheduleValueList.splice(i, 1);
            isAlreadySelected = true;
            i--;
          }
        }
        /*
        for (const [i,schedule] of this.selectedScheduleValueList) {
          if(ymd === schedule.lessonDate) {
            isAlreadySelected = true;
          }
        }
        */

        if(isAlreadySelected) {
          return;
        }else {
          // 룸 체크
          if(this.selectedRoom && this.selectedRoom.centerRoomId) {
            if( !await this.checkRoomDuet(ymd) ) {
                alert('해당룸은 이미 예약되어 있습니다.');
                return;
            }
          }

          // 이용권 유효성 체크
          for (const ticket of this.selectedTicketValueList) {
            /*
            console.log('currentDate: ', currentDate);
            console.log('cc_exp_start_dt: ', moment(ticket.cc_exp_start_dt,'YYYY-MM-DD'));
            console.log('cc_exp_end_dt: ', moment(ticket.cc_exp_end_dt));
            */

            // 만료일자 체크
            if( currentDate.isBefore(moment(ticket.expireStartDt)) || currentDate.isAfter(moment(ticket.expireEndDt)) ) {
              alert('이용권의 만료기간이 유효하지 않습니다.');
              return;
            }

            // 이용권 횟수 체크
            if( ticket.lessonResvCount + this.selectedScheduleValueList.length + 1 > ticket.lessonCount) {
              alert('이용권 횟수를 초과하였습니다.');
              return;
            }

            // 주 당 예약 횟수 제한 체크 - 백용훈 팀장 요청으로 삭제
            /*
            console.log('week: ',Utils.getAWeekdays(ymd, 0, 'M/DD'));
            console.log('scheduleList: ', this.selectedScheduleValueList);
            const aWeekDays = Utils.getAWeekdays(ymd, 0, 'M/DD');
            if( ticket.centerProduct.resvLimitType === 'W') {
              let weekCnt = 1; // 선택한 날짜 포함하여 1부터 시작
              for (const day of aWeekDays) {
                for (const schedule of this.selectedScheduleValueList) {
                  if(day.value === schedule.lessonDate) {
                    weekCnt++;
                  }
                }
              }
              if( weekCnt > ticket.centerProduct.resvLimitCount) {
                alert('주 예약 횟수 제한을 초과하였습니다.');
                return;
              }
            }
            */
          }

          // 선택된 일정(화면에 보여지는)
          this.selectedScheduleList.push(`${ymd}(${Utils.getDayOfWeekName(ymd)}) ${this.startTime} ~ ${this.endTime} ${roomName} / ${staffName} 강사`);

          // 선택된 일정(API input으로 사용될)
          let schedule = {};
          schedule.roomInfos = [];
          schedule.lessonDate = ymd;
          schedule.lessonStartTime = `${this.startTime}:00`;
          schedule.lessonEndTime = `${this.endTime}:00`;
          schedule.staffId = this.staffId;
          if( this.selectedRoom ) {
            const len = this.lessonTime / 30;
            let startTime = moment(this.startTime,'HH:mm');
            let useStartTime = this.startTime;
            for (let i = 0; i < len; i++) {
              let roomInfo = {};
              roomInfo.centerRoomId = this.selectedRoom.centerRoomId;
              roomInfo.useStartTime = useStartTime;
              roomInfo.useEndTime = startTime.add(30, 'minutes').format('HH:mm');
              schedule.roomInfos.push(roomInfo);
              startTime = moment(roomInfo.useEndTime,'HH:mm');
              useStartTime = roomInfo.useEndTime;
            }
          }
          this.selectedScheduleValueList.push(schedule);
        }
      }
  },
  // 휴일 구하기 함수..
  async getMonthHolidays(centerId, ym) {
      if (centerId !== 0) {
        api.get(`/admin/api/center/${centerId}/holiday/${ym}`)
            .then((res) => {
              // 휴일을 배열로 넣기..
              this.holidays = [];
              for (const d of res.data) {
                this.holidays.push(d.holidayDate);
              }
            })
            .catch((res) => {

            });
      }
    },
    async changeStaffId() {
      try {
        // console.log('context: ', this.context);
        const ym = `${this.context.activeDate.getFullYear()}${(this.context.activeDate.getMonth() + 1).toString().padStart(2, '0')}`;
        // console.log('ym: ', ym);
        const {data} = await this.onSearchList(ym);
        // console.log('data: ', data);
        const dFormat = 'YYYY-MM-DD';

        this.lessonDate  = {};
        for (const d of data) {
          const date = moment(d.cls_less_dt).format(dFormat);
          if (Utils.isEmpty(this.lessonDate[date])) {
            this.lessonDate[date] = [];
          }
          this.lessonDate[date].push(d);
        }

        // sort
        const dates = Object.keys(this.lessonDate);
        for (const d of dates) {
          this.lessonDate[d].sort((a, b) => (a.cls_less_start_tm < b.cls_less_start_tm ? -1 : 1));
        }

      } catch (error) {
        console.log(error);
      }
    },
    onSearchList(yearMonth) {
      // @스웨거: 상품의 월별(YYYYMM) 예약가능 스케줄 목록 조회
      return api.get(`/admin/api/center/${this.cId}/lesson/schedule/product/year-month/`, {
        params: {
          centerProductId: this.productId,
          staffId: this.staffId, // no required
          yearMonth: yearMonth,
          lessonType: "all",
        },
      });
    },
    async checkRoomDuet(lessonDate) {
        const len = this.lessonTime / 30;
        for (let i = 0; i < len; i++) {
          const startTime = moment(this.startTime,'HH:mm').add(i*30,'minutes');
          const useStartTime = startTime.format('HH:mm');
          const useEndTime = startTime.add(30, 'minutes').format('HH:mm');

          const { data } = await this.getCenterRoomReservation(useStartTime, useEndTime, lessonDate);

          // console.log('data: ', data);

          for (const room of data) {
            if( this.selectedRoom.centerRoomId === room.centerRoomId ) {
              // 룸 체크
              if ( room.limitCount > 0 && (this.selectedTicketValueList.length + room.totalCount) > room.limitCount ) {
                return false;
              }
              /*
              if( this.ticketType === 'D' && room.limitCount - room.totalCount < 2 ) {
                return false;
              }else if( this.ticketType === 'P' && room.limitCount - room.totalCount < 1 ) {
                return false;
              }else if( this.ticketType === 'O' && room.limitCount - room.totalCount < 1 ) {
                return false;
              }
              */
            }
          }
        }
        /*
        const { data } = await this.getCenterRoomReservation(this.startTime, this.endTime, lessonDate);

        // console.log('data: ', data);

        for (const room of data) {
          if( this.selectedRoom.centerRoomId === room.centerRoomId ) {
            if( room.totalCount >= room.limitCount ) {
              return false;
            }
          }
        }
        */

        return true;
    },
    getCenterRoomReservation(useStartTime, useEndTime, lessonDate) {
        const { centerId, centerLessonScheduleId } = this;
        // console.log(`centerId: ${centerId}, scheduleID: ${centerLessonScheduleId}`);
        // 스웨거 검색: 룸 예약 현황 조회
        return api.get(`/admin/api/centerRoom/reservation/status`, {
            params: {
                centerId,
                lessonDate,
                useStartTime,
                useEndTime,
                centerLessonScheduleId
            },
        });
    },
    convertTicketTypeFormat(type) {
      if (type === 'P') {
        return '개인';
      } else if (type === 'O') {
        return 'OT';
      } else if (type === 'D') {
        return '듀엣';
      } else if (type === 'G') {
        return '그룹';
      } else if (type === 'C') {
        return '쿠폰';
      } else if (type === 'T') {
        return '회원권';
      } else if (type === 'S') {
        return '운동복';
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.ui-calendar {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 32px;
  vertical-align: top;

  .input-area {
    position: relative;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      width: 43px;
      height: 32px;
      background: url('/img/icons/ic_calendar.png') no-repeat 0 0;
    }

    input {
      width: 100%;
      height: 32px;
      padding-left: 14px;
      border: 1px solid #ced4da;
      border-radius: 5px;
      font-size: 14px;
      color: #545454;
      cursor: pointer;
      vertical-align: top;
    }
  }

  .calendar-box {
    position: absolute;
    left: 0;
    top: 33px;
    background: #fff;

    z-index: 800;

    .b-calendar-header {
      display: none;
    }
  }

}
</style>
